// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("rescript/lib/js/curry.js");
var Decco = require("decco/src/Decco.bs.js");
var Js_dict = require("rescript/lib/js/js_dict.js");
var Js_json = require("rescript/lib/js/js_json.js");
var Belt_Array = require("rescript/lib/js/belt_Array.js");
var Belt_Option = require("rescript/lib/js/belt_Option.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var Util$SmartcutsMacros = require("../../../../bs-utils/src/Util.bs.js");
var Selector$SmartcutsMacros = require("../../Selector.bs.js");
var OptionUtils$SmartcutsMacros = require("../../../../bs-utils/src/OptionUtils.bs.js");
var StringUtils$SmartcutsMacros = require("../../../../bs-utils/src/StringUtils.bs.js");
var DOM__Element$SmartcutsMacros = require("../../DOM__Element.bs.js");
var Label__Shared$SmartcutsMacros = require("./Label__Shared.bs.js");

function t_encode(v) {
  return Js_dict.fromArray([
              [
                "selector",
                Selector$SmartcutsMacros.selector_encode(v.selector)
              ],
              [
                "labelText",
                Decco.stringToJson(v.labelText)
              ],
              [
                "sharedRootDepth",
                Decco.intToJson(v.sharedRootDepth)
              ]
            ]);
}

function t_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var selector = Selector$SmartcutsMacros.selector_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "selector"), null));
  if (selector.TAG === /* Ok */0) {
    var labelText = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "labelText"), null));
    if (labelText.TAG === /* Ok */0) {
      var sharedRootDepth = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "sharedRootDepth"), null));
      if (sharedRootDepth.TAG === /* Ok */0) {
        return {
                TAG: /* Ok */0,
                _0: {
                  selector: selector._0,
                  labelText: labelText._0,
                  sharedRootDepth: sharedRootDepth._0
                }
              };
      }
      var e = sharedRootDepth._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".sharedRootDepth" + e.path,
                message: e.message,
                value: e.value
              }
            };
    }
    var e$1 = labelText._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".labelText" + e$1.path,
              message: e$1.message,
              value: e$1.value
            }
          };
  }
  var e$2 = selector._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".selector" + e$2.path,
            message: e$2.message,
            value: e$2.value
          }
        };
}

function stringify(param) {
  return "{ labelText: " + (param.labelText + (", sharedRootDepth: " + (String(param.sharedRootDepth) + " }")));
}

function labelTextGet(param) {
  return param.labelText;
}

function mapLabelText(f, inputLabel) {
  return {
          selector: inputLabel.selector,
          labelText: Curry._1(f, inputLabel.labelText),
          sharedRootDepth: inputLabel.sharedRootDepth
        };
}

function isConfusingLabelText(inputValue, text) {
  var trimmedText = text.trim();
  var trimmedInputValue = inputValue.trim();
  if (trimmedText === "" || /\d+\s*\/\s*\d+/.test(trimmedText)) {
    return true;
  } else if (trimmedText !== "" && trimmedInputValue !== "") {
    return trimmedText.includes(trimmedInputValue);
  } else {
    return false;
  }
}

function t_encode$1(v) {
  switch (v) {
    case /* ViaId */0 :
        return ["ViaId"];
    case /* ViaName */1 :
        return ["ViaName"];
    case /* ViaAdjacentElement */2 :
        return ["ViaAdjacentElement"];
    
  }
}

function t_decode$1(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0) {
    switch (match._0) {
      case "ViaAdjacentElement" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* ViaAdjacentElement */2
                  };
          }
      case "ViaId" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* ViaId */0
                  };
          }
      case "ViaName" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* ViaName */1
                  };
          }
      default:
        
    }
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

function stringify$1(v) {
  switch (v) {
    case /* ViaId */0 :
        return "ViaId";
    case /* ViaName */1 :
        return "ViaName";
    case /* ViaAdjacentElement */2 :
        return "ViaAdjacentElement";
    
  }
}

var LabelDerivedVia = {
  t_encode: t_encode$1,
  t_decode: t_decode$1,
  stringify: stringify$1
};

function label_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var selector = Selector$SmartcutsMacros.selector_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "selector"), null));
  if (selector.TAG === /* Ok */0) {
    var labelText = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "labelText"), null));
    if (labelText.TAG === /* Ok */0) {
      var derivedVia = t_decode$1(Belt_Option.getWithDefault(Js_dict.get(dict$1, "derivedVia"), null));
      if (derivedVia.TAG === /* Ok */0) {
        return {
                TAG: /* Ok */0,
                _0: {
                  selector: selector._0,
                  labelText: labelText._0,
                  derivedVia: derivedVia._0
                }
              };
      }
      var e = derivedVia._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".derivedVia" + e.path,
                message: e.message,
                value: e.value
              }
            };
    }
    var e$1 = labelText._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".labelText" + e$1.path,
              message: e$1.message,
              value: e$1.value
            }
          };
  }
  var e$2 = selector._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".selector" + e$2.path,
            message: e$2.message,
            value: e$2.value
          }
        };
}

function label_encode(v) {
  return Js_dict.fromArray([
              [
                "selector",
                Selector$SmartcutsMacros.selector_encode(v.selector)
              ],
              [
                "labelText",
                Decco.stringToJson(v.labelText)
              ],
              [
                "derivedVia",
                t_encode$1(v.derivedVia)
              ]
            ]);
}

function t_encode$2(v) {
  return Js_dict.fromArray([
              [
                "sharedRootDepth",
                Decco.intToJson(v.sharedRootDepth)
              ],
              [
                "labels",
                Decco.arrayToJson(label_encode, v.labels)
              ]
            ]);
}

function t_decode$2(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var sharedRootDepth = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "sharedRootDepth"), null));
  if (sharedRootDepth.TAG === /* Ok */0) {
    var labels = Decco.arrayFromJson(label_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "labels"), null));
    if (labels.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: {
                sharedRootDepth: sharedRootDepth._0,
                labels: labels._0
              }
            };
    }
    var e = labels._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".labels" + e.path,
              message: e.message,
              value: e.value
            }
          };
  }
  var e$1 = sharedRootDepth._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".sharedRootDepth" + e$1.path,
            message: e$1.message,
            value: e$1.value
          }
        };
}

function mapAllLabelTexts(f, t) {
  return {
          sharedRootDepth: t.sharedRootDepth,
          labels: Belt_Array.map(t.labels, (function (label) {
                  return {
                          selector: label.selector,
                          labelText: Curry._1(f, label.labelText),
                          derivedVia: label.derivedVia
                        };
                }))
        };
}

function stringify$2(param) {
  return "{ labels: [" + (Belt_Array.map(param.labels, (function (param) {
                    return stringify$1(param.derivedVia) + ("(" + (StringUtils$SmartcutsMacros.quote(param.labelText) + ")"));
                  })).join(", ") + ("], sharedRootDepth: " + (String(param.sharedRootDepth) + " }")));
}

function updateSelector(f, t) {
  return {
          sharedRootDepth: t.sharedRootDepth,
          labels: Belt_Array.map(t.labels, (function (label) {
                  return {
                          selector: Curry._1(f, label.selector),
                          labelText: label.labelText,
                          derivedVia: label.derivedVia
                        };
                }))
        };
}

function forHtmlInputElement(inputElement) {
  var arg = OptionUtils$SmartcutsMacros.map(OptionUtils$SmartcutsMacros.optionalString(inputElement.id), (function (id) {
          return [
                  id,
                  /* ViaId */0
                ];
        }));
  var match = Belt_Option.flatMap((function (param) {
            return OptionUtils$SmartcutsMacros.orElse(param, arg);
          })(OptionUtils$SmartcutsMacros.map(OptionUtils$SmartcutsMacros.optionalString(inputElement.name), (function (name) {
                  return [
                          name,
                          /* ViaName */1
                        ];
                }))), (function (param) {
          var labelSource = param[1];
          return OptionUtils$SmartcutsMacros.map(Caml_option.nullable_to_opt(document.querySelector("label[for=" + (StringUtils$SmartcutsMacros.quote(param[0]) + "]"))), (function (element) {
                        return [
                                element,
                                labelSource
                              ];
                      }));
        }));
  var labelElementsWithDerivedVia;
  var exit = 0;
  if (match !== undefined) {
    var labelElement = match[0];
    if (labelElement.innerText.trim() !== "") {
      labelElementsWithDerivedVia = [[
          labelElement,
          match[1]
        ]];
    } else {
      exit = 1;
    }
  } else {
    exit = 1;
  }
  if (exit === 1) {
    labelElementsWithDerivedVia = Belt_Array.map(Belt_Array.keep(Belt_Array.keep(Belt_Array.keep(DOM__Element$SmartcutsMacros.proximalElementsWithInnerText(inputElement), (function (element) {
                        return !DOM__Element$SmartcutsMacros.isLikelyAutosuggestResult(inputElement, element);
                      })), (function (element) {
                    return !DOM__Element$SmartcutsMacros.doElementsGeometricallyOverlap(element, inputElement);
                  })), (function (element) {
                var arg = element.innerText;
                return !isConfusingLabelText(inputElement.value, arg);
              })), (function (element) {
            return [
                    element,
                    /* ViaAdjacentElement */2
                  ];
          }));
  }
  if (labelElementsWithDerivedVia.length === 0) {
    return ;
  }
  var sharedRoot = Belt_Array.reduce(labelElementsWithDerivedVia, inputElement, (function (sharedRoot, param) {
          var labelElement = param[0];
          if (DOM__Element$SmartcutsMacros.contains(sharedRoot, labelElement)) {
            return sharedRoot;
          } else {
            return DOM__Element$SmartcutsMacros.commonAncestor(sharedRoot, labelElement);
          }
        }));
  var sharedRootDepth = DOM__Element$SmartcutsMacros.getDepthRelativeToBody(sharedRoot);
  return {
          sharedRootDepth: sharedRootDepth,
          labels: Belt_Array.map(labelElementsWithDerivedVia, (function (param) {
                  var labelElement = param[0];
                  return {
                          selector: Selector$SmartcutsMacros.forDomElement(labelElement),
                          labelText: labelElement.innerText,
                          derivedVia: param[1]
                        };
                }))
        };
}

var forEventTarget = forHtmlInputElement;

function getLabelText(param) {
  return Belt_Option.map(Belt_Array.get(param.labels, 0), (function (param) {
                return param.labelText;
              }));
}

var RecordingAndAuthoring = {
  LabelDerivedVia: LabelDerivedVia,
  t_encode: t_encode$2,
  t_decode: t_decode$2,
  label_encode: label_encode,
  label_decode: label_decode,
  mapAllLabelTexts: mapAllLabelTexts,
  stringify: stringify$2,
  updateSelector: updateSelector,
  forHtmlInputElement: forHtmlInputElement,
  forEventTarget: forEventTarget,
  getLabelText: getLabelText
};

function fromRecordingAndAuthoring(param) {
  var match = Belt_Array.get(param.labels, 0);
  if (match !== undefined) {
    return {
            selector: match.selector,
            labelText: match.labelText,
            sharedRootDepth: param.sharedRootDepth
          };
  } else {
    return Util$SmartcutsMacros.logAndRaiseJsError("Expected at least 1 label when InputLabel.fromRecordingAndAuthoring()");
  }
}

function waitForElementInForegroundWithMatchingLabel(param, includeElementsNotVisible, selector) {
  return Label__Shared$SmartcutsMacros.waitForElementInForegroundWithMatchingLabel(param.selector, param.sharedRootDepth, includeElementsNotVisible, selector);
}

function waitForElementInBackgroundWithMatchingLabel(timeout, interval, tabId, param, $staropt$star, selector) {
  var includeElementsNotVisible = $staropt$star !== undefined ? $staropt$star : false;
  return Label__Shared$SmartcutsMacros.waitForElementInBackgroundWithMatchingLabel(timeout, interval, tabId, param.selector, param.sharedRootDepth, includeElementsNotVisible, selector);
}

exports.t_encode = t_encode;
exports.t_decode = t_decode;
exports.stringify = stringify;
exports.labelTextGet = labelTextGet;
exports.mapLabelText = mapLabelText;
exports.isConfusingLabelText = isConfusingLabelText;
exports.RecordingAndAuthoring = RecordingAndAuthoring;
exports.fromRecordingAndAuthoring = fromRecordingAndAuthoring;
exports.waitForElementInForegroundWithMatchingLabel = waitForElementInForegroundWithMatchingLabel;
exports.waitForElementInBackgroundWithMatchingLabel = waitForElementInBackgroundWithMatchingLabel;
/* Util-SmartcutsMacros Not a pure module */
